import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import "./agentDatatable.css";

const getInitials = (name) => {
  if (!name) return "?";
  const parts = name.trim().split(" ").filter(Boolean);
  if (parts.length > 1) {
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  }
  return parts.length ? parts[0].slice(0, 2).toUpperCase() : "?";
};

const formatBalance = (value) =>
  value ? parseFloat(value).toFixed(2) : "0.00";

export class Datatable extends Component {
  goToAgent = (name) => {
    this.props.history.push(`/business-consultancy/sourcing/agents/${name}`);
  };

  render() {
    const { myData } = this.props;

    return (
      <Fragment>
        <div className="table-responsive consultancy-agent-table-wrap">
          <table className="table table-hover consultancy-agent-table">
            <thead>
              <tr>
                <th scope="col">Agent</th>
                <th scope="col">Address</th>
                <th scope="col" className="text-right">
                  Rupee balance
                </th>
                <th scope="col" className="text-right">
                  RMB balance
                </th>
                <th scope="col" className="text-center">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {myData && myData.length > 0 ? (
                myData.map((employee, index) => (
                  <tr
                    key={employee.employeeId || index}
                    onClick={() => this.goToAgent(employee.name)}
                  >
                    <td>
                      <div className="consultancy-agent-cell">
                        <span className="consultancy-agent-avatar">
                          {getInitials(employee.name)}
                        </span>
                        <div>
                          <div className="consultancy-agent-name">
                            {employee.name}
                          </div>
                          <div className="consultancy-agent-designation">
                            {employee.designation}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="consultancy-agent-address">
                      {employee.address}
                    </td>
                    <td className="text-right">
                      <span
                        className={`consultancy-balance${
                          employee.rupeeBalance > 0
                            ? " consultancy-balance--active"
                            : ""
                        }`}
                      >
                        {formatBalance(employee.rupeeBalance)}
                      </span>
                    </td>
                    <td className="text-right">
                      <span
                        className={`consultancy-balance${
                          employee.rmbBalance > 0
                            ? " consultancy-balance--active"
                            : ""
                        }`}
                      >
                        {formatBalance(employee.rmbBalance)}
                      </span>
                    </td>
                    <td className="text-center">
                      <button
                        type="button"
                        className="consultancy-agent-view-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          this.goToAgent(employee.name);
                        }}
                      >
                        View <i className="fa fa-angle-right" />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className="consultancy-agent-empty">
                    No agents found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Fragment>
    );
  }
}

export default connect(null, {})(Datatable);
